import { history } from 'instantsearch.js/es/lib/routers';
import { simple as simpleStateMapping } from 'instantsearch.js/es/lib/stateMappings';

/**
 * Creates a routing configuration for InstantSearch
 * that safely ignores non-Algolia query parameters (UTM, etc.)
 *
 * @param {string} indexName - The Algolia index name
 * @returns {{ router: object, stateMapping: object }}
 */
export function createSearchRouting(indexName) {
  return {
    router: history({
      cleanUrlOnDispose: true,
      parseURL({ qsModule, location }) {
        const parsed = qsModule.parse(location.search.slice(1));
        return Object.fromEntries(
          Object.entries(parsed).filter(([key]) => key === indexName)
        );
      },
      createURL({ qsModule, routeState, location }) {
        const existingParams = qsModule.parse(location.search.slice(1));
        const nonAlgoliaParams = Object.fromEntries(
          Object.entries(existingParams).filter(([key]) => key !== indexName)
        );
        const merged = { ...nonAlgoliaParams, ...routeState };
        const queryString = qsModule.stringify(merged, {
          addQueryPrefix: true,
          arrayFormat: 'indices',
        });
        return `${location.pathname}${queryString}`;
      },
    }),
    stateMapping: simpleStateMapping(),
  };
}
